import React from "react";

import {
    UniformSlot,
    UniformSlotWrapperComponentProps
} from "@uniformdev/canvas-react";

import { BgColors } from "@/libraries/design/components/link/src/link";
import { TabDataType, TabsSection } from "@/libraries/design/patterns/tabs/src";

export interface UniformTabsProps {
    headerText: string;
    tabButtonsText: textObject[];
    bgColor?: BgColors;
}

type textObject = {
    fields: {
        text: {
            value: string;
        };
    };
};

interface VariableWidthTabsProps extends UniformTabsProps {
    columnWidth?: "full" | "eight";
}

const Tabs: React.FC<VariableWidthTabsProps> = ({
    columnWidth = "full",
    tabButtonsText,
    headerText,
    bgColor = "bgWhite"
}) => {
    const renderTabs: React.ComponentType<UniformSlotWrapperComponentProps> = ({
        items
    }) => {
        const tabsData = items.map(
            (item, index) =>
                ({
                    id: `tab-${index}`,
                    title: tabButtonsText[index]?.fields.text.value,
                    englishLabel: tabButtonsText[index]?.fields.text.value,
                    tabComponent: item
                } as TabDataType)
        );
        return (
            <TabsSection
                headerText={headerText}
                headerAlignment={columnWidth === "full" ? "center" : "left"}
                tabsData={tabsData}
                tabSize={columnWidth === "full" ? "large" : "small"}
                bgColor={bgColor}
            />
        );
    };

    return <UniformSlot name="tabContents" wrapperComponent={renderTabs} />;
};

export const UniformFullWidthTabs: React.FC<UniformTabsProps> = ({
    headerText,
    tabButtonsText,
    bgColor = "bgWhite"
}) => {
    return (
        <Tabs
            columnWidth="full"
            headerText={headerText}
            tabButtonsText={tabButtonsText}
            bgColor={bgColor}
        />
    );
};

export const UniformSmallTabs: React.FC<UniformTabsProps> = ({
    headerText,
    tabButtonsText,
    bgColor = "bgWhite"
}) => {
    return (
        <Tabs
            columnWidth="eight"
            headerText={headerText}
            tabButtonsText={tabButtonsText}
            bgColor={bgColor}
        />
    );
};
